import React from "react";
import { CheckCircle } from "lucide-react";
import { aboutData } from "../data/mock";

const AboutSection = ({ onOpenForm }) => {
  return (
    <section id="about" className="section-padding bg-white">
      <div className="container-custom px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={aboutData.image}
                alt="About Trademark Brand Logo"
                className="w-full h-auto object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-tr from-[#1e3a8a]/10 to-transparent"></div>
            </div>

            {/* Decorative Elements */}
            <div className="absolute -top-6 -right-6 w-32 h-32 bg-[#d4af37]/20 rounded-full blur-2xl"></div>
            <div className="absolute -bottom-6 -left-6 w-32 h-32 bg-[#1e3a8a]/20 rounded-full blur-2xl"></div>
          </div>

          {/* Right Content */}
          <div className="space-y-6">
            <div>
              <span className="text-[#d4af37] font-semibold text-sm uppercase tracking-wider">
                {aboutData.subtitle}
              </span>
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mt-3 mb-6">
                {aboutData.title}
              </h2>
            </div>

            <p className="text-lg text-gray-700 leading-relaxed">
              {aboutData.description}
            </p>

            <p className="text-base text-gray-600 leading-relaxed">
              {aboutData.content}
            </p>

            <p className="text-base text-gray-600 leading-relaxed">
              Our mission is simple: to provide world-class trademark registration services that combine 
              legal expertise with exceptional customer service. We believe every business deserves access 
              to professional trademark protection, regardless of size or budget. That's why we've created 
              flexible pricing plans and streamlined processes that make protecting your brand straightforward 
              and affordable.
            </p>

            <p className="text-base text-gray-600 leading-relaxed">
              When you choose Trademark Brand Logo, you're not just getting a trademark filing service – 
              you're gaining a dedicated partner committed to safeguarding your business's most valuable 
              asset: your brand identity. Our comprehensive approach covers every aspect of trademark 
              protection, from initial consultation and search to filing, monitoring, and enforcement.
            </p>

            {/* Features List */}
            <div className="grid md:grid-cols-2 gap-4 pt-6">
              {aboutData.features.map((feature, index) => (
                <div key={index} className="flex items-start space-x-3">
                  <CheckCircle className="w-6 h-6 text-[#d4af37] mt-1 flex-shrink-0" />
                  <span className="text-gray-700 font-medium">{feature}</span>
                </div>
              ))}
            </div>

            {/* Call to Action */}
            <div className="pt-6">
              <div className="bg-gradient-to-r from-[#1e3a8a]/5 to-[#d4af37]/5 p-6 rounded-xl border-l-4 border-[#1e3a8a]">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Ready to Protect Your Brand?
                </h3>
                <p className="text-gray-700 mb-4">
                  Join thousands of satisfied clients who trust us with their trademark protection needs. 
                  Get started today and secure your business's future.
                </p>
                <button onClick={onOpenForm} className="btn-primary">
                  Get Free Consultation
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
